
import { useIsMobile } from "@/hooks/use-mobile";
import { useLocation } from "react-router-dom";
import { MobileSidebar } from "./sidebar/MobileSidebar";
import { DesktopSidebar } from "./sidebar/DesktopSidebar";
import { ROUTES } from "@/utils/routes";

const Sidebar = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isAuthPage = location.pathname === ROUTES.AUTH;
  const isForgotPage = location.pathname === ROUTES.FORGOT_PASSWORD;
  
  // Don't show sidebar on home page or auth page
  if (isHomePage || isAuthPage || isForgotPage) {
    return null;
  }

  return (
    <>
      {/* Mobile sidebar - always render but control visibility with state */}
      <MobileSidebar />
      
      {/* Only render desktop sidebar for non-mobile */}
      {!isMobile && !isAuthPage && <DesktopSidebar />}
    </>
  );
};

export default Sidebar;
